import axiosInstance from "@/services/axiosInstance";
import { useQuery } from "@tanstack/react-query";

const instance = axiosInstance();

// prettier-ignore
const VALID_EXTENSIONS = new Set([
  ".jpg", ".jpeg", ".png", ".gif", ".svg", ".webp",
  ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx",
  ".txt", ".csv", ".json", ".xml", ".html", ".css", ".js",
  ".ts", ".tsx", ".php", ".py", ".java", ".c", ".cpp", ".go", ".rb"
]);

// get file extension
export function useFileType(proposal_id, files) {
  const getFileExtension = (filename) => {
    if (!filename) return "";
    const parts = filename.split(".");
    if (parts.length < 2) return ""; // No extension found
    const ext = `.${parts.pop().toLowerCase()}`;
    return VALID_EXTENSIONS.has(ext) ? ext : "";
  };

  const updatedAttachments =
    files?.map((attachment) => ({
      ...attachment,
      extension: getFileExtension(attachment.name),
    })) || [];

  const checkFileType = async () => {
    // Filter files without extensions
    const filesToCheck =
      files?.filter((file) => {
        const ext = getFileExtension(file.name);
        return !ext;
      }) || [];

    // Early return if no files need checking
    if (filesToCheck.length === 0) return updatedAttachments;

    // Don't check if too many files
    if (filesToCheck.length > 15) return updatedAttachments;

    const response = await instance.post(
      `/contract/check-file-type`,
      filesToCheck,
      {
        timeout: 50000,
      }
    );

    // Merge results with existing extensions
    return updatedAttachments.map((attachment) => {
      const serverExtension = response.data?.find(
        (resFile) => resFile.attachmentId === attachment.attachmentId
      )?.extension;

      return serverExtension
        ? { ...attachment, extension: serverExtension }
        : attachment;
    });
  };

  return useQuery({
    queryKey: ["fileType", proposal_id],
    queryFn: checkFileType,
  });
}
